<img alt="Person" [src]="url" class="rounded-circle" (error)="onImageError()" [style.width.px]="size" [style.height.px]="size"/>
